export default __webpack_public_path__ + "static/media/image4.c659ffe6.png";